var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIPhoneX = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 417,
    height: 846,
    viewBox: "0 0 417 846",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 417,
    height: 846
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M417 0H0V846H417V0ZM107.082 22.4464V26.9025L107.153 26.9003L107.082 27.3976C107.082 39.1558 116.606 48.6878 128.355 48.6878H288.645C300.394 48.6878 309.918 39.1558 309.918 27.3976L309.847 26.9003L309.918 26.9025V22.4464C309.918 19.4384 312.354 17 315.36 17L328.104 17C348.027 17 357.989 17 365.934 20.0045C378.422 24.727 388.279 34.5926 392.998 47.0902C396 55.0415 396 65.0112 396 84.9505V761.049C396 780.989 396 790.958 392.998 798.91C388.279 811.407 378.422 821.273 365.934 825.995C357.989 829 348.027 829 328.104 829H88.8958C68.9725 829 59.0108 829 51.066 825.995C38.5784 821.273 28.7208 811.407 24.0021 798.91C21 790.958 21 780.989 21 761.049V84.9505C21 65.0112 21 55.0415 24.0021 47.0902C28.7208 34.5926 38.5784 24.727 51.066 20.0045C59.0108 17 68.9725 17 88.8958 17L101.64 17C104.646 17 107.082 19.4384 107.082 22.4464Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 89.7273C3 65.869 3 53.9399 6.13555 44.2857C12.4727 24.774 27.7639 9.47657 47.2677 3.13683C56.9179 0 68.8421 0 92.6906 0H324.309C348.158 0 360.082 0 369.732 3.13683C389.236 9.47657 404.527 24.774 410.864 44.2857C414 53.9399 414 65.869 414 89.7273V756.273C414 780.131 414 792.06 410.864 801.714C404.527 821.226 389.236 836.523 369.732 842.863C360.082 846 348.158 846 324.309 846H92.6906C68.8421 846 56.9179 846 47.2677 842.863C27.7639 836.523 12.4727 821.226 6.13555 801.714C3 792.06 3 780.131 3 756.273V89.7273Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 217H415.5C416.328 217 417 217.665 417 218.485V315.515C417 316.335 416.328 317 415.5 317H414V217Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 337L1.49999 337C0.671567 337 -5.18746e-06 336.339 -5.11622e-06 335.524L-4.2483e-08 277.476C2.87579e-08 276.661 0.671573 276 1.5 276L3.00001 276L3 337Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 256L1.49999 256C0.671567 256 -5.18746e-06 255.339 -5.11622e-06 254.524L-4.24881e-08 196.476C2.87528e-08 195.661 0.671573 195 1.5 195L3.00001 195L3 256Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 166L1.5 166C0.671571 166 -2.68311e-06 165.328 -2.61071e-06 164.5L-7.59548e-08 135.5C-3.54603e-09 134.672 0.671573 134 1.5 134L3 134L3 166Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 89.7273C5 65.7134 5.02466 54.1806 8.03774 44.9035C14.1772 26.0005 28.9913 11.1806 47.8859 5.03887C57.1588 2.02469 68.6864 2 92.6906 2H324.309C348.314 2 359.841 2.02469 369.114 5.03887C388.009 11.1806 402.823 26.0005 408.962 44.9035C411.975 54.1806 412 65.7134 412 89.7273V756.273C412 780.287 411.975 791.819 408.962 801.096C402.823 820 388.009 834.819 369.114 840.961C359.841 843.975 348.314 844 324.309 844H92.6906C68.6864 844 57.1588 843.975 47.8859 840.961C28.9913 834.819 14.1772 820 8.03774 801.096C5.02466 791.819 5 780.287 5 756.273V89.7273Z",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 89.7273C4 65.7912 4.01233 54.0603 7.08665 44.5946C13.325 25.3873 28.3776 10.3286 47.5768 4.08785C57.0383 1.01235 68.7643 1 92.6906 1H324.309C348.236 1 359.962 1.01235 369.423 4.08785C388.622 10.3286 403.675 25.3873 409.913 44.5946C412.988 54.0603 413 65.7912 413 89.7273V756.273C413 780.209 412.988 791.94 409.913 801.405C403.675 820.613 388.622 835.671 369.423 841.912C359.962 844.988 348.236 845 324.309 845H92.6906C68.7643 845 57.0383 844.988 47.5768 841.912C28.3776 835.671 13.325 820.613 7.08665 801.405C4.01233 791.94 4 780.209 4 756.273V89.7273Z",
    stroke: "url(#paint1_linear)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    width: 6,
    height: 4,
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 85,
    width: 4,
    height: 5,
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 85,
    width: 4,
    height: 5,
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 755,
    width: 4,
    height: 6,
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 755,
    width: 4,
    height: 6,
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 842,
    width: 6,
    height: 4,
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.082 26.9025V22.4464C107.082 19.4384 104.646 17 101.64 17L88.8958 17C68.9725 17 59.0108 17 51.066 20.0045C38.5784 24.727 28.7208 34.5926 24.0021 47.0902C21 55.0415 21 65.0112 21 84.9505V761.049C21 780.989 21 790.959 24.0021 798.91C28.7208 811.407 38.5784 821.273 51.066 825.995C59.0108 829 68.9725 829 88.8958 829H328.104C348.028 829 357.989 829 365.934 825.995C378.422 821.273 388.279 811.407 392.998 798.91C396 790.959 396 780.989 396 761.049V84.9505C396 65.0112 396 55.0415 392.998 47.0902C388.279 34.5926 378.422 24.727 365.934 20.0045C357.989 17 348.028 17 328.104 17L315.36 17C312.354 17 309.918 19.4384 309.918 22.4464V26.9025L309.847 26.9003L309.918 27.3976C309.918 39.1558 300.394 48.6878 288.645 48.6878H128.355C116.606 48.6878 107.082 39.1558 107.082 27.3976L107.153 26.9003L107.082 26.9025Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251 39C255.418 39 259 35.4183 259 31C259 26.5817 255.418 23 251 23C246.582 23 243 26.5817 243 31C243 35.4183 246.582 39 251 39Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251 38C254.866 38 258 34.866 258 31C258 27.134 254.866 24 251 24C247.134 24 244 27.134 244 31C244 34.866 247.134 38 251 38Z",
    fill: "#55ADFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251 35C253.209 35 255 33.2091 255 31C255 28.7909 253.209 27 251 27C248.791 27 247 28.7909 247 31C247 33.2091 248.791 35 251 35Z",
    fill: "#55ADFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251 30C251.552 30 252 29.5523 252 29C252 28.4477 251.552 28 251 28C250.448 28 250 28.4477 250 29C250 29.5523 250.448 30 251 30Z",
    fill: "#55ADFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184 31C184 29.3431 185.343 28 187 28H230C231.657 28 233 29.3431 233 31V31C233 32.6569 231.657 34 230 34H187C185.343 34 184 32.6569 184 31V31Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.0426,
    y1: -0.00000279698,
    x2: 414.095,
    y2: 845.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 365,
    y1: -0.00000242913,
    x2: 419.5,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIPhoneX);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/iPhoneX.646bc0a7871a0aa585ad1390dfccf080.svg";